import bgTranslations from './bg.json'
import enTranslations from './en.json'

export type Language = 'bg' | 'en'

export const LANGUAGES: { code: Language; name: string; nativeName: string; flag: string }[] = [
  { code: 'bg', name: 'Bulgarian', nativeName: 'Български', flag: '🇧🇬' },
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧' },
]

export const DEFAULT_LANGUAGE: Language = 'bg'

export const translations: Record<Language, typeof bgTranslations> = {
  bg: bgTranslations,
  en: enTranslations,
}

/**
 * Get nested translation value by dot-separated key path
 */
export function getTranslation(
  translations: typeof bgTranslations,
  key: string
): string {
  const keys = key.split('.')
  let value: unknown = translations

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = (value as Record<string, unknown>)[k]
    } else {
      return key // Return key if not found
    }
  }

  return typeof value === 'string' ? value : key
}

/**
 * Interpolate variables in translation string
 * Supports both {{key}} and {key} formats
 * Example: "Hello {{name}}" with { name: "World" } => "Hello World"
 */
export function interpolate(
  template: string,
  variables: Record<string, string | number>
): string {
  return template.replace(/\{\{(\w+)\}\}|\{(\w+)\}/g, (match, doubleKey, singleKey) => {
    const key = doubleKey ?? singleKey
    return key in variables ? String(variables[key]) : match
  })
}

/**
 * Get the stored language preference
 */
export function getStoredLanguage(): Language {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE
  const stored = localStorage.getItem('language')
  if (stored && (stored === 'bg' || stored === 'en')) {
    return stored
  }
  // Try to detect from browser
  const browserLang = navigator.language.split('-')[0]
  if (browserLang === 'bg') return 'bg'
  return DEFAULT_LANGUAGE
}

/**
 * Store the language preference
 */
export function setStoredLanguage(language: Language): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem('language', language)
  }
}
